<button mat-button matTooltip="Login" matTooltipPosition="below" class="logo push-right-4">
  <mat-icon svgIcon="icon:spoutLogo"></mat-icon>
</button>
<mat-divider vertical="true"></mat-divider>
<span class="title">LOGIN</span>
